<template>
  <h3>Visualizar Publicidade</h3>
  <div v-for="field in fields" :key="field.key" class="row">
    <div v-if="field.type === 'select'" class="col-md-12">
      <label :for="field.key">{{ field.label }}</label>
      <br />
      <select v-model="publicidade[field.key]" disabled class="ant-select ant-select-lg custom-select">
        <option v-for="option in field.options" :key="option.value" :value="option.value">{{ option.label }}</option>
      </select>
    </div>
    <div v-else-if="field.type === 'date'" class="col-md-12">
      <label :for="field.key">{{ field.label }}</label>
      <br />
      <input type="text" :value="stringData(publicidade[field.key])" readonly="true" class="ant-input ant-input-lg" />
    </div>
    <div v-else-if="field.type === 'link'" class="col-md-12">
      <div class="link-container">
        <label :for="field.key">{{ field.label }}</label>
        <br />
        <template v-if="publicidade.arquivo">
          <a :href="publicidade.arquivo" target="_blank">Clique para visualizar o arquivo</a>
        </template>
        <template v-else> Arquivo não encontrado </template>
      </div>
    </div>
    <div v-else class="col-md-12">
      <label :for="field.key">{{ field.label }}</label>
      <br />
      <input :type="field.type" :value="publicidade[field.key]" readonly="true" class="ant-input ant-input-lg" />
    </div>
  </div>
  <a-button class="yellow-button" @click="voltar"> Voltar </a-button>
</template>

<script>
import { getPublicidadeById } from '@/components/service/publicidadeService';
import { createArquivoURLPublica } from '@/utils/filews';

export default {
  name: 'PageVisualizarPublicidade',
  data() {
    return {
      publicidade: {},
      fields: [
        { key: 'nome', label: 'Nome', type: 'text' },
        {
          key: 'tipo',
          label: 'Tipo',
          type: 'select',
          options: [
            { label: 'Vídeo', value: 'VIDEO' },
            { label: 'Banner', value: 'BANNER' },
          ],
        },
        { key: 'dataInicio', label: 'Data Início', type: 'date' },
        { key: 'dataFim', label: 'Data Fim', type: 'date' },
        { key: 'arquivo', label: 'Arquivo', type: 'link' },
        {
          key: 'situacao',
          label: 'Status',
          type: 'select',
          options: [
            { label: 'Ativo', value: 'ATIVO' },
            { label: 'Inativo', value: 'INATIVO' },
          ],
        },
      ],
    };
  },
  methods: {
    async carregarPublicidade() {
      if (this.$route.query.id) {
        const idUrl = this.$route.query.id;
        const res = await getPublicidadeById(idUrl);
        const urlArquivo = await createArquivoURLPublica(res.data.idArquivo);

        this.publicidade = {
          nome: res.data.nome,
          tipo: res.data.tipo,
          dataInicio: res.data.dataInicio,
          dataFim: res.data.dataFim,
          arquivo: urlArquivo,
          situacao: res.data.situacao,
        };
      }
    },
    stringData(data_str) {
      if (!data_str) {
        return '-';
      }
      const dataCriacao = new Date(data_str);
      return dataCriacao.toLocaleDateString('pt-BR');
    },
    voltar() {
      this.$router.go(-1);
    },
  },
  created() {
    this.carregarPublicidade();
  },
};
</script>

<style scoped>
.yellow-button {
  background-color: #faad14;
  border-color: #faad14;
  color: white;
  margin-top: 10px;
}

.yellow-button:hover {
  background-color: #ffc53d;
  border-color: #ffc53d;
  color: white;
}
.custom-select {
  width: 100%;
  height: 40px;
  font-size: 16px;
  padding: 8px 12px;
}
.link-container {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
